<template>
  <div id="data-table" class="uk-card uk-card-default uk-card-body uk-card-hover">
    <div class="table-title uk-container">
      <h1>{{name}}</h1>
    </div>
    <div class="table-buttons uk-container dt-top-container">
      <div class="dt-top-group">
        <button class="uk-button uk-button-primary" @click="exportExcel">Export XLS</button>
        <button class="uk-button uk-button-primary" v-if="false" @click="exportPDF">Export PDF</button>
        <button v-if="action_button" class="uk-button uk-button-secondary" @click="emitActionButton">{{action_button}}
        </button>
      </div>
      <div class="uk-inline">
        <button class="uk-button uk-button-default search-elem" type="button">Searching: {{search_by}}</button>
        <div uk-dropdown="pos: bottom-center">
          <ul class="uk-nav uk-dropdown-nav">
            <li v-for="(c, i) in searchFields" :key=i><a @click="search_by = c.data_name">{{c.name}}</a></li>
          </ul>
        </div>
      </div>
      <div class="uk-search uk-search-default search-elem">
        <span uk-search-icon></span>
        <input v-model="search_input" class="uk-search-input" @input="doSearch" type="search" placeholder="">
      </div>
    </div>
  <div v-if="message"><p>{{message}}</p></div>
    <div class="uk-overflow-auto">
      <table class="uk-table uk-table-hover uk-table-middle uk-table-divider">
        <!-- start table header -->
        <thead>
        <tr>
          <th v-for="(c,i) in reformated_data.columns" :key=i :class="c.class" @click="sortTable(c.data_name)"><span
                  :uk-icon="c.sort_icon"></span><a> {{c.name}}</a></th>
          <!--<th class="uk-table-shrink"></th>-->
        </tr>
        </thead>

        <!-- start data -->
        <tbody>
        <tr v-for="(r, i) in reformated_data.rows" :key=i @click="() => handleRowClick(r)">
          <data-cell v-for="(d, i) in r" :data="d" :key="i" @output="emitOutput" @action="emitCellAction"></data-cell>
        </tr>
        </tbody>
      </table>
      <div class="row-length">
        <div class="uk-align-right">
          <ul class="uk-breadcrumb">
            <li v-for="r in rowLimit" :class="{'uk-disabled uk-text-bold': r.active}" :key="r.limit"><a
                    @click="resetRowLimit(r.limit)">{{r.limit}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	// REFERENCE FOR TABLE COLUMNS:
	// .uk-table-shrink	    reduce the column width to fit its content.
	// .uk-table-expand	    expand the column width to fill the remaining space and apply a min-width.
	// .uk-width-*	        Add one of these classes from the Width component to a <th> or <td> element to modify the column width. ex. uk-width-small
	// .uk-table-link	    To link an entire cell, add this class to a <th>or <td> element and insert an <a>element. Add the .uk-link-resetclass from the Link component to reset the default link styling.
	// .uk-preserve-width	Since images are responsive by default in UIkit, using an image inside a table cell with the .uk-table-shrink class would reduce the image width to 0. To prevent this behavior, add the .uk-preserve-width class from the Base component to the <img> element.
	// .uk-text-truncate	When applying a fixed width to a table cell, you might want to add this class from the Text component to the <td> element to truncate the text.
	// .uk-text-nowrap	    Add this class from the Text component to keep text from wrapping, for example when using the .uk-table-shrink class.

	import sort from '../../utils/sort.js'
	import api from 'axios'
	import pdfMake from 'pdfmake/build/pdfmake.js'
	import pdfFonts from 'pdfmake/build/vfs_fonts.js'
	// var pdfMake = require('pdfmake/build/pdfmake.js');
	// var pdfFonts = require('pdfmake/build/vfs_fonts.js');
	pdfMake.vfs = pdfFonts.pdfMake.vfs;
	import moment from "moment";
	import DataCell from "./dataCell";

	export default {
		name: "DataTable",
		components: {DataCell},
		props: ['data', 'name', 'action_button', "search_fields", "message", "col_conversion"],
		data: function () {
			return {
				prop_data: [
					{
						Driver_Name: 'John Smith',
						KMI: 42.1,
						Date: "2018-01-01",
						Survey_Comments: "Lorem ipsum dolor sit amet, this is a comment this is a comment.",
						Dashboard_Link: '/dashboard/johns-smith/'
					},
					{
						Driver_Name: 'Bob Smith',
						KMI: 22.1,
						Date: "2018-01-02",
						Survey_Comments: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
						Dashboard_Link: '/dashboard/bob-smith/'
					},
					{
						Driver_Name: 'Frank Smith',
						KMI: 100.1,
						Date: "2018-01-04",
						Survey_Comments: "Johnny Appleseed was a drug dealer.",
						Dashboard_Link: '/dashboard/frank-sinatra/'
					},
					{
						Driver_Name: 'Frank Smith',
						KMI: 100.1,
						Date: "2018-01-04",
						Survey_Comments: "Johnny Appleseed was a drug dealer.",
						Dashboard_Link: '/dashboard/frank-sinatra/'
					},
					{
						Driver_Name: 'Frank Smith',
						KMI: 100.1,
						Date: "2018-01-04",
						Survey_Comments: "Johnny Appleseed was a drug dealer.",
						Dashboard_Link: '/dashboard/frank-sinatra/'
					},
					{
						Driver_Name: 'Frank Smith',
						KMI: 100.1,
						Date: "2018-01-04",
						Survey_Comments: "Johnny Appleseed was a drug dealer.",
						Dashboard_Link: '/dashboard/frank-sinatra/'
					},
					{
						Driver_Name: 'Frank Smith',
						KMI: 100.1,
						Date: "2018-01-04",
						Survey_Comments: "Johnny Appleseed was a drug dealer.",
						Dashboard_Link: '/dashboard/frank-sinatra/'
					},
					{
						Driver_Name: 'Frank Smith',
						KMI: 100.1,
						Date: "2018-01-04",
						Survey_Comments: "Johnny Appleseed was a drug dealer.",
						Dashboard_Link: '/dashboard/frank-sinatra/'
					}

				],
				// action_button: false,
				search_input: "",
				search_by: "Last_Name",
				search_data: [],
				sort_descending: false,
				set_row_limit: 1000,
				table_name: "Table",
				columns: [],
				pdf_table: [],
				rowLimit: [
					{
						limit: 5,
						active: false,
					},
					{
						limit: 10,
						active: false,
					},
					{
						limit: 20,
						active: false,
					},
					{
						limit: 100,
						active: false,
					}
				]
			}

		},
		methods: {
		    convertColumn: function(name){
		      if (this.col_conversion) {
		        if (name in this.col_conversion){
                  return this.col_conversion[name]
                } else {
                  return name.replace(/_/g, ' ').toUpperCase()
                }
              } else {
		        return name.replace(/_/g, ' ').toUpperCase()
              }

            },

			handleRowClick: function (rowdata) {
				const link = rowdata[0].link;
				this.$router.push(link);
			},
			emitOutput: function (output) {
				this.$emit('output', output)
			},
			emitActionButton: function () {
				this.$emit('action', true)
			},
			emitCellAction: function (val) {
				this.$emit('cellAction', val)
			},
			doSearch: function () {
				this.search_data = sort.stringSearch(this.data, this.search_by, this.search_input)
			},
			resetRowLimit: function (limit) {
				this.set_row_limit = limit;
				let _t = this
				this.rowLimit.forEach(function (obj, i) {
					_t.rowLimit[i]['active'] = false;
					if (obj.limit == limit) {
						_t.rowLimit[i]['active'] = true;

					}
				})

			},
			sortTable: function (data_name) {
				this.sort_descending = !this.sort_descending;
				this.data = sort.sortBy(this.data, data_name, this.sort_descending)
				let _t = this
				let sort_icon = ''
				if (this.sort_descending) {
					sort_icon = 'arrow-down'
				} else {
					sort_icon = 'arrow-up'
				}
				this.reformated_data['columns'].forEach(function (obj, i) {
					_t.reformated_data['columns'][i]['sort_icon'] = "table";
					if (obj.data_name == data_name) {
						_t.reformated_data['columns'][i]['sort_icon'] = sort_icon
					}
				})

			},
			exportExcel: function () {
				api.post("https://1u95s2sc29.execute-api.us-east-1.amazonaws.com/dev/", this.data).then(
						function (response) {
							console.log(response)
							window.open(response['data'], '_blank')
						}
				)
			},
			exportPDF: function () {
				let _t = this;
				let table_widths = [];
				let even_width = false;
				let orientation = 'portrait'
				if (_t.columns.length > 5){
				  even_width = ((1/_t.columns.length)*100).toString() + '%'
                  orientation = 'landscape'
                }

				_t.columns.forEach(function () {
				    if (even_width){
				      table_widths.push(even_width)
                    } else {
				      table_widths.push('*')
                    }

				})
				var docDefinition = {
					header: {
						margin: 10,
						columns: [
							{
								margin: [10, 0, 0, 0],
								text: moment().format('LLL')
							},
							{
								margin: [10, 0, 0, 0],
								text: this.name
							}
						]
					},
                    pageOrientation: orientation,
					content: [
						{
							layout: 'lightHorizontalLines',

							table: {
								headerRows: 1,
								widths: table_widths,

								body: _t.pdf_table
							}
						}
					]
				};
				console.log(docDefinition)
				pdfMake.createPdf(docDefinition).download(this.name + '.pdf');
			}
		},
		computed: {

			searchFields: function() {
				if (this.search_fields) {
					return this.search_fields.map(d => { return {data_name: d, name: d}});
				} else {
					return this.reformated_data.columns
        }

      },
			reformated_data: function () {
				this.pdf_table = []

				function generate_class_from_data(data) {
					let s_data = "None";
					if (data != null) {
						s_data = data.toString()
					}
					if (s_data.length > 50) {
						return 'uk-table-shrink'
					} else if (s_data.charAt(0) == '/') {
						return 'uk-table-shrink uk-text-expand uk-text-nowrap'
					} else {
						return 'uk-table-shrink uk-text-nowrap'
					}
				}

				let prop_data = []
				if (this.search_data.length > 0) {
					// console.log('slicing this.search_data')
					// prop_data = this.search_data.slice(0, this.set_row_limit);
					prop_data = this.search_data
				} else {
					// console.log('slicing this.data')
					// prop_data = this.data.slice(0, this.set_row_limit);
					prop_data = this.data
				}

				let column_reference = prop_data[0];
				let reformatted_data = {};
				let column_list = []
				this.columns = []
				let _t = this
				// create a column dictionary
				reformatted_data['columns'] = [];
				reformatted_data['rows'] = []

				for (var key in column_reference) {
				    let converted_name = _t.convertColumn(key)
					column_list.push(converted_name)
					_t.columns.push(converted_name)
					reformatted_data['columns'].push(
							{
								// name: key.replace('_', " "),
                                name: converted_name,
								class: generate_class_from_data(column_reference[key]),
								data_name: key,
								sort_icon: "",

							}
					)
				}
				_t.pdf_table.push(column_list)
				prop_data.forEach(function (obj) {
					function emitClick(input) {
						console.log(input)
					}

					let row_object = [];
					let row_list = []
					let i = 0;
					for (var k in obj) {
						if (obj[k] == null) {
							obj[k] = ""
						}
						row_list.push(obj[k]);
						if (obj[k].toString().charAt(0) == '/') {
							//if we find a link, put it in as a key in the first object
							row_object[0].link = obj[k];
							row_object.push(
									{
										html: '<button class="uk-button uk-button-text"><a href="' + obj[k] + '">' + reformatted_data['columns'][i]['name'].replace('link', '') + '</a></button>',
										class: reformatted_data['columns'][i]['class'],
										model: false,
										id: ""
									}
							)
						}
						else if (typeof(obj[k]) == "object") {
							let info = obj[k]
							// console.log("OBJECT ROW")
							// console.log(obj)
							// console.log(obj[k])
							row_object.push(
									{
										html: info.html,
										class: reformatted_data['columns'][i]['class'],
										model: k,
										input_type: info.input_type,
										id: info.id,
										emit_click: info.emit_click || false,
										emit_value: info.emit_value || null,
										icon: info.icon || null,
									})
						}
						else {
							row_object.push(
									{
										class: reformatted_data['columns'][i]['class'],
										html: obj[k],
										model: false,
										id: ""
									}
							)
						}

						i += 1;
					}
					reformatted_data['rows'].push(row_object)
					_t.pdf_table.push(row_list)
				});

				reformatted_data['rows'] = reformatted_data['rows'].slice(0, this.set_row_limit)
				return reformatted_data
			}
		},

    mounted() {
			//set search by variable
      if (typeof this.search_fields === 'string' ) {
      	this.search_by = this.search_fields;
      } else {
      	this.search_by = this.search_fields[0];
      }
    }
	}
</script>

<style lang="less" scoped>
  .table-wrapper {
    padding: 15px;
    border: 1px solid black;
    margin: 20px;
  }

  .uk-table th {
    text-align: center !important;
  }

  .table-title {
    margin: 2em 0;
  }

  .dt-top-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2em;

    .dt-top-group {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      flex-shrink: 1;
      white-space: nowrap;

      & > * {
        margin-right: 11px;
      }

    }

    .search-elem {
      width: 275px;
    }

  }

  tr {
    cursor: pointer;
  }

  #data-table {
    background: white !important;
    margin: 15px;
  }

  @media only screen and  (max-width: 959px) {
    .dt-top-container {
      flex-direction: column;

      & > * {
        margin-bottom: .8em;
      }
    }
  }

  a {
    text-decoration: none;
  }

</style>
